// TODO: 測試用資料，記得刪
export const ORDER_STATUS_OPTIONS = [
  {
    label: '報名中',
    value: '報名中',
  },
  {
    label: '已取消',
    value: '已取消',
  },
  {
    label: '未付款',
    value: '未付款',
  },
  {
    label: '已結束',
    value: '已結束',
  },
  {
    label: '已評價',
    value: '已評價',
  },
];

export const PAYMENT_OPTIONS = [
  {
    label: '未付款',
    value: '未付款',
  },
  {
    label: '信用卡',
    value: '信用卡',
  },
  {
    label: '點數',
    value: '點數',
  },
];

export const RATING_OPTIONS = Array.from({ length: 5 }, (_, index) => ({
  label: `${5 - index}星`,
  value: 5 - index,
}));
